import * as React from 'react'
import algoliaAnalytics from 'search-insights'
import { useInstantSearch } from 'react-instantsearch'
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'

export function InsightsMiddleware() {
  const { addMiddlewares } = useInstantSearch()

  React.useEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: algoliaAnalytics,
    })

    return addMiddlewares(middleware)
  }, [addMiddlewares])

  return null
}
